import { useShow } from '@refinedev/core'
import { Show } from '@refinedev/mui'
import { Alert, Box, Chip, Link, Stack, Typography } from '@mui/material'

const MemoryActivityShow: React.FC = () => {
  const { query } = useShow({ resource: 'memory-activity' })
  const record = query.data?.data

  return (
    <Show isLoading={query.isLoading} title="Memory Activity Detail">
      {record ? (
        <Stack spacing={1.5}>
          <Typography variant="body2"><strong>ID:</strong> {record.id}</Typography>
          <Typography variant="body2"><strong>Org:</strong> {record.org_name || record.org_uuid}</Typography>
          <Typography variant="body2"><strong>Action:</strong> {record.action}</Typography>
          <Typography variant="body2"><strong>Need ID:</strong> {record.need_id ?? 'N/A'}</Typography>
          <Typography variant="body2"><strong>Opportunity UUID:</strong> {record.opportunity_uuid ?? 'N/A'}</Typography>
          <Typography variant="body2"><strong>Created:</strong> {record.created_at ? new Date(record.created_at).toLocaleString() : ''}</Typography>

          {record.memory_content && (
            <Box sx={{ p: 1.5, bgcolor: 'action.hover', borderRadius: 1 }}>
              <Typography variant="subtitle2" gutterBottom>
                Memory {record.action === 'create' ? 'Created' : record.action === 'update' ? 'Updated' : 'Affected'}
                {record.memory_status && <Chip size="small" label={record.memory_status} sx={{ ml: 1 }} />}
                {record.memory_category && <Chip size="small" label={record.memory_category} variant="outlined" sx={{ ml: 0.5 }} />}
                {record.memory_scope && <Chip size="small" label={record.memory_scope} variant="outlined" sx={{ ml: 0.5 }} />}
              </Typography>
              <Typography variant="body2">{record.memory_content}</Typography>
              {record.memory_point_id && (
                <Link href={`/memories/${record.memory_point_id}`} variant="body2" sx={{ mt: 0.5, display: 'inline-block' }}>
                  View memory →
                </Link>
              )}
            </Box>
          )}

          <Typography variant="body2"><strong>Reasoning:</strong> {record.reasoning || 'N/A'}</Typography>
          <Typography variant="body2"><strong>Original Answer:</strong> {record.original_answer || 'N/A'}</Typography>
          <Typography variant="body2"><strong>Edited Answer:</strong> {record.edited_answer || 'N/A'}</Typography>
          <Typography variant="body2">
            <strong>Memories Used:</strong>{' '}
            {Array.isArray(record.memories_used) && record.memories_used.length
              ? record.memories_used.join(', ')
              : 'None'}
          </Typography>
        </Stack>
      ) : (
        <Alert severity="info">No activity found.</Alert>
      )}
    </Show>
  )
}

export default MemoryActivityShow
